import { Box, Stack, Switch, styled } from "@mui/material";
import { background, black, button, divider, text } from "@/theme/colors";

export const PopoverContainer = styled(Box)`
  width: 712px;
  background-color: ${background.white};
  max-height: 80vh;
  outline: none;
  display: flex;
  flex-direction: column;

  &:focus {
    outline: none;
  }
`;

export const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 0;
`;

export const PanelHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
`;

export const SlidingTabContainer = styled(Box)`
  position: relative;
  display: flex;
  background-color: ${black[99]};
  border-radius: 24px;
  padding: 4px;
`;

export const SlidingIndicator = styled(Box)`
  position: absolute;
  top: 4px;
  height: calc(100% - 8px);
  background-color: white;
  border-radius: 20px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  transition:
    left 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;
`;

export const SlidingTabButton = styled("button")<{ $isActive: boolean }>`
  position: relative;
  z-index: 1;
  border: none;
  border-radius: 20px;
  height: 36px;
  min-width: 90px;
  padding: 8px 16px;
  background-color: transparent;
  color: ${({ $isActive }) => ($isActive ? black[30] : black[70])};
  cursor: pointer;
  transition: color 0.2s ease;
  font-family: inherit;

  &:hover {
    background-color: transparent;
  }

  &:focus {
    outline: none;
  }
`;

export const ScrollableContent = styled(Box)`
  padding: 0px 24px 16px;
  overflow-y: auto;
  flex: 1;
  max-height: 550px;
`;

export const FooterContainer = styled(Stack)`
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid ${divider.middle};
`;

export const DisplayColumnItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isDragging",
})<{ isDragging: boolean }>`
  padding: 6px 0;
  background-color: ${({ isDragging }) => (isDragging ? divider.low : "transparent")};
  transition: background-color 0.2s ease;
`;

export const NumberBadge = styled(Box)`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid ${divider.high};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: ${text.secondary};
  flex-shrink: 0;
`;

export const DragHandle = styled(Box)`
  display: flex;
  align-items: center;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const StyledSwitch = styled(Switch)(({}) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: button.primary,
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
  },
}));
